import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ", ";\n  margin: 0;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { LINE_GRAY } from '../colors';
import { marginVerticalKeys, marginVerticalMixin } from '../mixins/layout';
import { withOmitProps } from '../helpers/elements';
var Hr = styled.hr.withConfig(withOmitProps([].concat(marginVerticalKeys)))(_templateObject(), LINE_GRAY, marginVerticalMixin);
export default Hr;